import { render, staticRenderFns } from "./CarrierGallery.vue?vue&type=template&id=634c43b4&scoped=true"
import script from "./CarrierGallery.vue?vue&type=script&lang=js"
export * from "./CarrierGallery.vue?vue&type=script&lang=js"
import style0 from "./CarrierGallery.vue?vue&type=style&index=0&id=634c43b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634c43b4",
  null
  
)

export default component.exports